// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SalaryStatus {\n  padding: 16px;\n  margin: 16px 0;\n  border-radius: 4px; }\n  .SalaryStatus.SalaryStatus--success {\n    background: aquamarine; }\n  .SalaryStatus.SalaryStatus--warning {\n    background: bisque; }\n  .SalaryStatus.SalaryStatus--error {\n    background: darksalmon; }\n", ""]);
// Exports
module.exports = exports;
